
import React from 'react';

import umbrella from '@nackle/umbrella';
const { loadBundle, loadStringAttributeBundles } = umbrella;
import { getString } from '@nackle/intl-tools';

const DEFAULT_WINDOW_TITLE_KEY = 'global.section.main.item.label.home';
const DEFAULT_WINDOW_TITLE = 'Home';

export default class CMXContent extends React.Component {
    state = {
        contentFetched: false,
        error: false
    };

    async componentDidMount() {
        const { locale, route } = this.props;
        this.setState( { error: false } );
        let bundles = [];
        if ( route.match && route.match.bundles ) {
            bundles = route.match.bundles;
        }
        let stringAttributeBundles = [];
        if ( route.match && route.match.stringAttributeBundles ) {
            stringAttributeBundles = route.match.stringAttributeBundles;
        }
        try {
            await loadBundle( [ ...bundles, 'navigation', 'solution', 'umbrella', 'origami', 'comments' ], locale );
            if ( stringAttributeBundles && stringAttributeBundles.length > 0 ) {
                await loadStringAttributeBundles( [ ...stringAttributeBundles ], locale );
            }
            this.setState( { contentFetched: true } );
        } catch ( error ) {
            console.error( 'Error loading bundles', error );
            this.setState( { error: true } );
            throw new Error( error );
        }
    }

    setWindowTitle = () => {
        const { route, solutionName } = this.props;

        const routeTitleKey = route && route.match ? route.match.title : DEFAULT_WINDOW_TITLE_KEY;
        let translatedTitle = getString( routeTitleKey );
        if ( translatedTitle.indexOf( 'Missing locale value' ) >= 0 ) {
            translatedTitle = DEFAULT_WINDOW_TITLE;
        }

        if ( String( solutionName ).trim().length > 0 ) {
            translatedTitle = `${ solutionName } | ${ translatedTitle }`;
        }

        document.title = translatedTitle;
    };

    render() {
        const { contentFetched, error } = this.state;

        if ( contentFetched && !error ) {

            this.setWindowTitle();

            return (
                <div>
                    { this.props.children }
                </div>
            );
        } else if ( !error ) {
            return null;
        } else if ( error ) {
            return (
                <div className="error">
                    <h1>Something went wrong</h1>
                </div>
            );
        }
    }
}